import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".EncryptedFormField-module_noPadding__5-ab- {\n  padding: 0;\n}\n\n.EncryptedFormField-module_formFieldWrap__v6N08 {\n  margin-bottom: var(--pp-spacing-m);\n}";
var styles = {"noPadding":"EncryptedFormField-module_noPadding__5-ab-","formFieldWrap":"EncryptedFormField-module_formFieldWrap__v6N08"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=EncryptedFormField.module.scss.js.map
